import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import MerchantSaveReturnUnsave from "./MerchantSaveReturnUnsave";

const MerchantAddReturnProduct = ({ close, getMerchantReturnList }) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const [returnUnsaveList, setReturnUnsaveList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = Form.useForm();
  const [selectedData, setSelectedData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [inputedQuantityConversion, setInputedQuantityConversion] = useState(0);

  const columns = [
    {
      title: "Product",
      dataIndex: ["returnunsaveproductinfo", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["returnunsaveproductinfo", "description"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Qty/Grams",
      dataIndex: "quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  //GOODS
  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  //GOODS
  const getReturnUnsaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/return-unsave-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setReturnUnsaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFetchProduct = (prodID) => {
    var params = {
      id: prodID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/merchant/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });
        form.setFieldsValue({
          quantity: "",
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getProductList();
    getReturnUnsaveList();
  }, [getProductList, getReturnUnsaveList]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInPO();
    }, 2000);
  };

  // const handleOkReturn = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setOpenDrawer(false);
  //     setConfirmLoading(false);
  //     handleCreateReturn();
  //   }, 2000);
  // };

  //GOODS
  const handleDeleteProductInPO = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/merchant/delete-product-in-return", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getReturnUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  //GOODS
  // const handleCreateReturn = () => {
  //   const formdata = new FormData();
  //   formdata.append("user_id", userData.data.id);
  //   setLoadings(true);
  //   axios
  //     .post("user/merchant/save-return-unsave", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data === "success") {
  //         rerunNotif("success", "Saved to Return successfully.");
  //         setTimeout(() => {
  //           close();
  //           setLoadings(false);
  //           setLoading(false);
  //           getMerchantReturnList();
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoadings(false);
  //     });
  // };

  //GOODS
  const handleAddProductTo = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }

    var error = [];
    if (
      parseInt(inputedQuantityConversion) >
      parseInt(specProductInfo.ready && specProductInfo.data.quantity)
    ) {
      error = "error";
      rerunNotif("error", "Invalid quantity input.");
    }
    if (error.length > 0) {
      console.log("Something went wrong.");
    } else {
      setLoadings(true);
      setLoading(true);
      axios
        .post("user/merchant/new-return-product-unsave", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "product-exist") {
            rerunNotif("error", "Product already added!");
            setTimeout(() => {
              form.setFieldsValue({
                quantity: 0,
              });
              setLoadings(false);
              setLoading(false);
            }, 1000);
          }
          if (data === "success") {
            rerunNotif("success", "Created new return successfully.");
            setTimeout(() => {
              form.setFieldsValue({
                quantity: "",
              });
              setLoadings(false);
              setLoading(false);
              getReturnUnsaveList();
            }, 1000);
          }
          setInputedQuantityConversion(0);
        })
        .catch((error) => {
          setLoadings(false);
        });
    }
  };

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button type="primary" icon={<CloseOutlined />} onClick={() => close()}>
          Close
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Creating Return Product
                </Typography.Title>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table
                  {...tableProps}
                  pagination={{
                    position: ["bottomCenter"],
                  }}
                  columns={tableColumns}
                  dataSource={
                    returnUnsaveList.data.length > 0
                      ? returnUnsaveList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                />
                <div
                  style={{
                    display: returnUnsaveList.data.length > 0 ? "flex" : "none",
                  }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Button
                      type="primary"
                      loading={loadings}
                      onClick={() => setOpenDrawer(true)}
                    >
                      {loadings ? "Loading" : "Create"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>Add Product</Typography.Title>
              </div>
              <div>
                <Form
                  form={form}
                  layout="vertical"
                  name="add-return-product"
                  initialValues={{ remember: true }}
                  onFinish={handleAddProductTo}
                  autoComplete="off"
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      margin: 0,
                    }}
                  >
                    <Form.Item
                      name="product"
                      label="Product"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select product"
                        onChange={
                          (e) => handleFetchProduct(e)
                          // console.log("EVENT", e)
                        }
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {productList.data.length > 0 ? (
                          productList.data.map((data, index) => (
                            <Select.Option value={data.id} key={index}>
                              {data.product}
                            </Select.Option>
                          ))
                        ) : (
                          <Select.Option value="">
                            No raw product found!
                          </Select.Option>
                        )}
                      </Select>
                    </Form.Item>

                    {specProductInfo.ready && specProductInfo.data && (
                      <>
                        <Form.Item
                          name="quantity"
                          label={
                            specProductInfo.ready &&
                            parseFloat(specProductInfo.data.is_per_piece) === 1
                              ? "Quantity"
                              : "Grams"
                          }
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            value={inputedQuantityConversion}
                            size="large"
                            style={{ width: "100%" }}
                            step="1"
                            onChange={(value) => {
                              if (value === null) {
                                setInputedQuantityConversion(0);
                              } else {
                                setInputedQuantityConversion(value);
                              }
                            }}
                          />
                        </Form.Item>

                        <Typography style={{ fontWeight: "bold" }}>
                          Available Quantity : {specProductInfo.data.quantity}
                        </Typography>
                      </>
                    )}
                  </Space>

                  <Form.Item style={{ marginTop: "20px" }}>
                    <Button
                      type="primary"
                      loading={loadings}
                      htmlType="submit"
                      style={{ width: "100%", borderRadius: "20px" }}
                      disabled={parseInt(inputedQuantityConversion) === 0}
                    >
                      {loadings ? "Loading" : "Add"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* <Modal
        title="Are you sure to create this return?"
        open={openDrawer}
        onOk={handleOkReturn}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenDrawer(false)}
        centered
      /> */}

      {openDrawer && (
        <MerchantSaveReturnUnsave
          originalTab={() => close()}
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getReturnUnsaveList()}
          rerunList={() => getMerchantReturnList()}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </>
  );
};

export default MerchantAddReturnProduct;
